'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.deleteBlockedVisitorByChannel = deleteBlockedVisitorByChannel;
exports.deleteBlockedVisitorById = deleteBlockedVisitorById;
exports.blockVisitorByChannel = blockVisitorByChannel;
exports.fetchAllBlockedVisitors = fetchAllBlockedVisitors;
exports.fetchMessages = fetchMessages;
exports.createMessage = createMessage;
exports.updateMessageById = updateMessageById;
exports.deleteMessageById = deleteMessageById;
exports.fetchAdminChatConfig = fetchAdminChatConfig;
exports.fetchVisitorForChannel = fetchVisitorForChannel;
exports.fetchConversations = fetchConversations;
exports.fetchChatHistoryChunk = fetchChatHistoryChunk;
exports.fetchMessagePortalSettings = fetchMessagePortalSettings;
exports.updateMessagePortalSettings = updateMessagePortalSettings;
exports.fetchMessageUserSettings = fetchMessageUserSettings;
exports.updateMessageUserSettings = updateMessageUserSettings;
exports.createContactFromVisitor = createContactFromVisitor;
exports.closeConversationByChannel = closeConversationByChannel;
exports.fetchWidgetInfo = fetchWidgetInfo;
exports.fetchWidgetChatConfig = fetchWidgetChatConfig;
exports.fetchPublicChatHistoryChunk = fetchPublicChatHistoryChunk;
exports.sendEmbedCodeEmailRequest = sendEmbedCodeEmailRequest;
exports.fetchAgent = fetchAgent;
exports.fetchSmartLists = fetchSmartLists;
exports.fetchSalesViews = fetchSalesViews;
exports.fetchMeetingsLinks = fetchMeetingsLinks;
exports.fetchUsers = fetchUsers;
exports.fetchContact = fetchContact;
exports.fetchTeams = fetchTeams;
exports.fetchSnippets = fetchSnippets;
exports.fetchWebpageScreenshotRequest = fetchWebpageScreenshotRequest;
exports.sendOnlineNotice = sendOnlineNotice;
exports.sendOfflineNotice = sendOfflineNotice;
exports.sendHeartbeat = sendHeartbeat;

var _apiClient = require('conversations-core/http/apiClient');

var _apiClient2 = _interopRequireDefault(_apiClient);

var _noAuthApiClient = require('conversations-core/http/noAuthApiClient');

var _noAuthApiClient2 = _interopRequireDefault(_noAuthApiClient);

var _hubspot = require('hubspot.PortalIdParser');

var _hubspot2 = _interopRequireDefault(_hubspot);

var _Defaults = require('conversations-schema/constants/Defaults');

var _PreviewTypes = require('conversations-schema/constants/PreviewTypes');

var _PreviewTypes2 = _interopRequireDefault(_PreviewTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MESSAGES_API_PREFIX = 'messages/v2';

function deleteBlockedVisitorByChannel(channel) {
  return _apiClient2.default.delete(MESSAGES_API_PREFIX + '/blocked-visitors/channel/' + channel);
}

function deleteBlockedVisitorById(blockId) {
  return _apiClient2.default.delete(MESSAGES_API_PREFIX + '/blocked-visitors/' + blockId);
}

function blockVisitorByChannel(channel, reason, ipBlock) {
  return _apiClient2.default.post(MESSAGES_API_PREFIX + '/blocked-visitors', {
    data: {
      channel: channel,
      reason: reason,
      ipBlock: ipBlock
    }
  });
}

function fetchAllBlockedVisitors() {
  return _apiClient2.default.get(MESSAGES_API_PREFIX + '/blocked-visitors');
}

// messages, private
function fetchMessages() {
  return _apiClient2.default.get(MESSAGES_API_PREFIX + '/welcomeMessage/all');
}

function createMessage(message) {
  return _apiClient2.default.post(MESSAGES_API_PREFIX + '/welcomeMessage', { data: message });
}

function updateMessageById(message) {
  return _apiClient2.default.put(MESSAGES_API_PREFIX + '/welcomeMessage/' + message.id, {
    data: message
  });
}

function deleteMessageById(messageId) {
  return _apiClient2.default.delete(MESSAGES_API_PREFIX + '/welcomeMessage/' + messageId);
}

function fetchAdminChatConfig(uuid) {
  return _apiClient2.default.get(MESSAGES_API_PREFIX + '/chatconfig', {
    query: { uuid: uuid }
  });
}

function fetchVisitorForChannel(channel) {
  return _apiClient2.default.get(MESSAGES_API_PREFIX + '/visitor', {
    query: { channel: channel }
  });
}

function fetchConversations() {
  return _apiClient2.default.get(MESSAGES_API_PREFIX + '/conversation', {
    timeout: 60000
  });
}

function fetchChatHistoryChunk(_ref) {
  var channel = _ref.channel,
      startTime = _ref.startTime;

  return _apiClient2.default.get(MESSAGES_API_PREFIX + '/history', {
    query: {
      count: _Defaults.DEFAULT_HISTORY_COUNT,
      channel: channel,
      startTime: startTime
    }
  });
}

function fetchMessagePortalSettings() {
  return _apiClient2.default.get(MESSAGES_API_PREFIX + '/portalSettings');
}

function updateMessagePortalSettings(portalSettings) {
  return _apiClient2.default.put(MESSAGES_API_PREFIX + '/portalSettings', {
    data: portalSettings
  });
}

function fetchMessageUserSettings() {
  return _apiClient2.default.get(MESSAGES_API_PREFIX + '/userSettings');
}

function updateMessageUserSettings(userSettings) {
  return _apiClient2.default.put(MESSAGES_API_PREFIX + '/userSettings', {
    data: userSettings
  });
}

function createContactFromVisitor(_ref2) {
  var channel = _ref2.channel,
      email = _ref2.email,
      firstName = _ref2.firstName,
      lastName = _ref2.lastName;

  return _apiClient2.default.post(MESSAGES_API_PREFIX + '/visitor/', {
    query: { channel: channel },
    data: {
      email: email,
      firstName: firstName,
      lastName: lastName
    }
  });
}

function closeConversationByChannel(channel) {
  return _apiClient2.default.put(MESSAGES_API_PREFIX + '/conversation/close/' + channel);
}

// messages, public
function fetchWidgetInfo(id, messagesUtk, hubspotUtk) {
  return _noAuthApiClient2.default.get(MESSAGES_API_PREFIX + '/message/public/' + id, {
    query: {
      portalId: _hubspot2.default.get(),
      hubspotUtk: hubspotUtk || undefined,
      messagesUtk: messagesUtk
    }
  });
}

function fetchWidgetChatConfig(_ref3) {
  var sessionId = _ref3.sessionId,
      messageId = _ref3.messageId,
      uuid = _ref3.uuid;

  return _noAuthApiClient2.default.get(MESSAGES_API_PREFIX + '/chatconfig/public', {
    query: {
      portalId: _hubspot2.default.get(),
      sessionId: sessionId,
      messageId: messageId,
      uuid: uuid
    }
  });
}

function fetchPublicChatHistoryChunk(_ref4) {
  var sessionId = _ref4.sessionId,
      startTime = _ref4.startTime;

  return _noAuthApiClient2.default.get(MESSAGES_API_PREFIX + '/history/public', {
    query: {
      count: _Defaults.DEFAULT_HISTORY_COUNT,
      sessionId: sessionId,
      startTime: startTime
    }
  });
}

// email
function sendEmbedCodeEmailRequest(recipientEmail) {
  return _apiClient2.default.post(MESSAGES_API_PREFIX + '/email/embed', {
    query: { recipientEmail: recipientEmail }
  });
}

function fetchAgent(agentId, agentType) {
  var portalId = _hubspot2.default.get();

  return _noAuthApiClient2.default.get(MESSAGES_API_PREFIX + '/message/agents/' + agentId, {
    query: { agentType: agentType, portalId: portalId }
  });
}

// smart lists
function fetchSmartLists() {
  return _apiClient2.default.get('contacts/v1/lists/internal/all', {
    query: {
      portalId: _hubspot2.default.get()
    }
  });
}

// sales views
function fetchSalesViews() {
  return _apiClient2.default.get('sales/v2/settings/views/contacts');
}

// meetings
function fetchMeetingsLinks() {
  return _apiClient2.default.get('meetings/v1/link');
}

// users
function fetchUsers() {
  return _apiClient2.default.get('users/v2/app/scopes/salesaccelerator-access/hubs/' + _hubspot2.default.get() + '/hub-users', {
    query: {
      'plus-hidden': true
    }
  });
}

function fetchContact(email) {
  return _apiClient2.default.get('/contacts/v1/contact/email/' + email + '/profile', {
    query: { portalId: _hubspot2.default.get() }
  });
}

// teams
function fetchTeams() {
  return _apiClient2.default.get('app-users/v1/teams', {
    query: { portalId: _hubspot2.default.get() }
  });
}

// snippets
function fetchSnippets() {
  return _apiClient2.default.get('snippets/v1/snippets');
}

// hubshot
function fetchWebpageScreenshotRequest(targetUrl, type) {
  var resizeWidth = void 0;
  var resizeHeight = void 0;

  switch (type) {
    default:
    case _PreviewTypes2.default.DESKTOP:
      resizeWidth = 538;
      resizeHeight = 323;
      break;
    case _PreviewTypes2.default.TABLET:
      resizeWidth = 301;
      resizeHeight = 396;
      break;
  }

  return _apiClient2.default.post('hubshot/v2/screenshots', {
    data: {
      targetUrl: targetUrl,
      resizeWidth: resizeWidth,
      resizeHeight: resizeHeight,
      useCache: true,
      height: resizeHeight * 3 + 75,
      width: resizeWidth * 3
    }
  });
}

// presence
function sendOnlineNotice() {
  return _apiClient2.default.put(MESSAGES_API_PREFIX + '/presence/online');
}

function sendOfflineNotice() {
  return _apiClient2.default.put(MESSAGES_API_PREFIX + '/presence/offline');
}

function sendHeartbeat() {
  return _apiClient2.default.put(MESSAGES_API_PREFIX + '/presence/heartbeat');
}


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/data/MessagesClient.js
// module id = 45
// module chunks = 0 1